// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"a246c34d","355":"80dd95ac","356":"af325184","642":"77cefe19","808":"78962463","914":"d30888f7","974":"172871c7","997":"3aa0d6b4"}[chunkId] + ".chunk.js";
};